import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { deleteToken, readToken } from '@app/services/localStorage.service';
import { notificationController } from '@app/controllers/notificationController';

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const apiInterceptor = async (config: AxiosRequestConfig) => {
  config.headers = { ...config.headers, Authorization: `Bearer ${readToken()}` };

  return config;
};

const errorInterceptor = async (axiosError: AxiosError) => {
  const status = axiosError.response?.status ?? 0;

  if (status === 401) {
    deleteToken();
    window.location.replace('http://localhost:3000/auth/login');
  } else if (status == 429) notificationController.error({ message: 'درخواست خیلی زیاد! بعدا دوباره تلاش کنید' });
  else if (status >= 500) notificationController.error({ message: 'خطای غیر منتظره' });

  return Promise.reject(axiosError);
};

// Request interceptors
httpApi.interceptors.request.use(apiInterceptor);

// Response interceptors
httpApi.interceptors.response.use((res) => res, errorInterceptor);
